import { GraphQLClient } from 'graphql-request';
import { gql } from 'graphql-tag';
import { getAuthGateUrl, getCookieDomain, isAltAuthgateUrl } from './config';
import Cookies from 'js-cookie';
export { getClient, gql };
var $client;
export var COOKIE_DOMAIN_HEADER = 'x-oneauth-cookie-domain';
function initClient() {
  var url = getAuthGateUrl();
  $client = new GraphQLClient(url, {
    credentials: 'include',
    mode: 'cors',
    headers: {
      Accept: 'application/json'
    }
  });
  if (Cookies.get('_px3')) {
    $client.setHeader('x-px-chegg-cookie', Cookies.get('_px3'));
  }
  if (isAltAuthgateUrl()) {
    $client.setHeader(COOKIE_DOMAIN_HEADER, getCookieDomain());
  }
  $client.setHeader('x-chegg-web-client', 'true');
}
function getClient() {
  if (!$client) {
    initClient();
  }
  return $client;
}